import { useTranslation } from "react-i18next";
import { Flex, Box, Button } from "@chakra-ui/react";
import { getAppValue } from "src/utils/environment";
import { H3, Subtitle } from "src/atoms/typography";
import Modal from "src/components/Modal";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as MotionBaby } from "./motion-baby.svg";
import { ReactComponent as MotionDog } from "./motion-dog.svg";
import { ReactComponent as ErrorIcon } from "./motion-error.svg";

const contentEnum = [
  {
    heading: "motionDetection.explainer.noMotion.heading",
    opacity: "0.4",
    errorIcon: false
  },
  {
    heading: "motionDetection.explainer.motionDetected.heading",
    opacity: "1",
    errorIcon: false
  },
  {
    heading: "motionDetection.explainer.unableToDetect.heading",
    opacity: "1",
    errorIcon: true
  }
];

export default function MotionInfo({ isOpen, onClose, toggleMotionSettings }) {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Box width="280px">
        <Box mt="24px" mx="24px">
          <H3 mb="24px" color="highEmphasis">
            {t("motionDetection.explainer.heading")}
          </H3>
          {contentEnum.map(({ heading, opacity, errorIcon }) => {
            return (
              <Flex mb="16px" key={heading} alignItems="center">
                <Box position="relative">
                  <SvgContainer
                    icon={getAppValue({
                      bibino: MotionBaby,
                      barkio: MotionDog
                    })}
                    size="24px"
                    fill="primary"
                    mr="16px"
                    opacity={opacity}
                  />
                  {errorIcon && (
                    <Box position="absolute" bottom="-30%" right="25%">
                      <ErrorIcon />
                    </Box>
                  )}
                </Box>
                <Box>
                  <Subtitle mb="4px" color="highEmphasis">
                    {t(heading)}
                  </Subtitle>
                </Box>
              </Flex>
            );
          })}
        </Box>
        <Flex mt="16px" pr="8px" pb="8px" justifyContent="flex-end">
          <Button
            variant="flatPrimary"
            onClick={() => {
              toggleMotionSettings();
              onClose();
            }}
            minWidth="80px"
            mr="8px"
          >
            {t("buttons.adjustSensitivity")}
          </Button>
          <Button variant="flatPrimary" onClick={onClose} minWidth="80px">
            {t("buttons.ok")}
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
}
